<template>
  <div>
    <div class="text-right mb-3 dropdown">
      <base-button type="primary" size="lg" class="btn-fill text-right" data-toggle="dropdown">
        Export Application
      </base-button>
      <ul class="dropdown-menu">
        <li><a @click="doExport('original')">{{ $t('medium_grant.revision_tab__original_version') }}</a></li>
        <li><a @click="doExport('revised')" v-if="hasRevision">{{ $t('medium_grant.revision_tab__revised_version') }}</a></li>
      </ul>
    </div>
    <div class="full-overlay d-flex" v-if="exporting">
      <div class="mx-auto mt-5">
        <h3 class="mb-2">Please wait, generating export...</h3>
        <h4>It could take a few minutes.</h4>

        <!-- <h5 v-if="currentTab">Exporting page {{currentTab}} of {{totalTabs}}</h5> -->
        <h5 v-if="processing">Awaiting export to be processed by server...</h5>
      </div>
    </div>
  </div>
</template>

<script>
  import {EventBus} from '@/event-bus.js';
  import {ApplicationService} from '@/services';
  import html2canvas from 'html2canvas';
  import swal from 'sweetalert2';

  export default {
    data() {
      return {
        masterInstance: {},
        loggedUser: {},
        exporting: false,
        currentTab: 0,
        totalTabs: 0,
        processing: false
      }
    },
    props: ['applicationId', 'grantId', 'hasRevision', 'conceptStatus'],
    created() {
      this.loggedUser = this.$store.getters['Auth/loggedUser'];
    },
    methods: {
      async doExport(version) {
        let vm = this;

        vm.exporting = true;
        let loader = vm.$loading.show();

        vm.formatContent();

        EventBus.$emit('get-master-instance');

        let images = [];
        let tabs = 0;

        vm.masterInstance.$children.forEach(function (item) {
          tabs += item.$children[0].$children[0].tabs.length
        })

        vm.totalTabs = tabs-1;

        // for (let i = 0; i < tabs; i++) {
        //   vm.currentTab = i;
        //   let screenshot = await vm.takeScreenshot();
        //   images.push(screenshot);
        //   vm.doNextStep();
        // }

        vm.processing = true;

       /*let response = await ApplicationService.exportApplication({
          version: version || 'original',
          applicationId: vm.applicationId,
          grantId: vm.grantId,
          // images: images
        });*/
let response = {};
  if(vm.conceptStatus == "conceptNote"){
    response = await ApplicationService.exportConceptApplication({
          version: version || 'original',
          applicationId: vm.applicationId,
          grantId: vm.grantId,
          // images: images
        });
  }
  else{
    response = await ApplicationService.exportApplication({
          version: version || 'original',
          applicationId: vm.applicationId,
          grantId: vm.grantId,
          // images: images
        });
  }
        

        vm.exporting = false;
        loader.hide();

        if (response.data.success === true) {
          let pdf_download = response.data.pdf_download;
          let zip_download = response.data.zip_download;

          let html = 'Your application export is ready! <br/>' +
            'An email with export has been sent to: ' + vm.loggedUser.email + '<br/><br/>' +
            '<a class="btn btn-primary" target="_blank" href="' + pdf_download + '">Download Export</a>';

          if (zip_download.length > 0) {
            html += '<a class="btn btn-warning" target="_blank" href="' + zip_download + '">Download Attachments</a>';
          }

          await swal({
            title: this.$t('general.notification__success'),
            html: html,
            type: 'success',
            showConfirmButton: false
          });

          // force page-reload
          window.location.reload();
        }
      },
      formatContent() {
        $('#applicationComponent textarea').each(function () {
          $(this).after('<p class="mt-2 white-space-pre-wrap">' + $(this).val() + '</p>')
          $(this).remove();
        })

        $('#applicationComponent .radio-component').each(function () {
          $(this).removeClass('radio-component');
        })

        $('input[type="radio"]').css('opacity', '1');
        $('.form-check-inline input[type="radio"] + label').css('margin-right', '1rem');

        $('#applicationComponent .btn').hide();

        $("#applicationComponent").bind("DOMSubtreeModified", function() {
          $('#applicationComponent .btn').hide();
        });
      },
      async takeScreenshot() {
        let promise = new Promise((resolve, reject) => {
          setTimeout(() => resolve("done!"), 800)
        });
        await promise;

        return await html2canvas($('#applicationComponent').get(0)).then(function (canvas) {
          let imageData = canvas.toDataURL('image/png');
          return imageData;
        });
      },
      doNextStep() {
        let vm = this;
        let activeMasterTab = vm.masterInstance.$children.filter(children => children.active);
        activeMasterTab[0].$children[0].$children[0].doNext();
      }

    },
    mounted() {
      let vm = this;
      EventBus.$off('send-master-instance');
      EventBus.$on('send-master-instance', data => {
        vm.masterInstance = data;
      })
    }
  }
</script>
<style scoped>
  .dropdown-menu a
  {
    display: block;
    width: 100%;
    padding: 10px 15px;
    cursor: pointer;
  }
</style>
